// extracted by mini-css-extract-plugin
export default {"button":"Button_button__WvfhE","disabled":"Button_disabled__4-rW6"};